<template>
	<div id="down-main-xp">
		<img class="logo" :src="httpImg + `/invitation-xp/logo-xp3.png`" />
		<div class="h1">
			{{ $t('down.anytime') }}
			<img :src="httpImg + `/invitation-xp/invite-16.png`" />
			XP {{ $t('down.trade') }}
		</div>
		<img class="bg" :src="httpImg + `/invitation-xp/invite-bg4.png`" />

		<div class="ul">
			<template v-for="(item,index) in ulList">
				<div @click="linkClick(index)" class="li">
					<img v-if="index < 3"
						:src="httpImg + `/invitation-xp/${index == 2 ? 'invite-15':'invite-14'}.png`" />
					{{item}}
				</div>
			</template>
		</div>


		<div class="alert" v-show="alertShow">
			<span>{{message}}</span>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapActions
	} from 'vuex';

	export default {
		name: 'Download',
		data() {
			return {
				iosUrl: '',
				androidUrl: '',
				alertShow: false,
				message: '',
				email: 'jinguozi007@gmail.com',
				ulList: [
					'App Store',
					'AD_HOC',
					'Android APK',
					this.$t('down.register_guide')
				]
			}
		},
		components: {},
		computed: {
			//获取用户信息
			...mapState('app', {
				theme: state => state.theme,
				DDNS: state => state.DDNS,
				httpImg: state => state.httpImg
			}),
		},
		mounted() {
			this.getDownUrl();
		},
		watch: {
			$route() {
				if (window._czc) {
					let location = window.location
					let contentUrl = location.pathname + location.hash
					let refererUrl = '/'
					window._czc.push(['_trackPageview', contentUrl, refererUrl])
				}
			}
		},
		methods: {
			linkClick(i) {
				let url = ''
				if (i == 1) {
					url = 'https://hjtnky.com/483858384'
				}
				if (i == 2) { //this.DDNS['oss-file'][0] 
					url = 'https://f.xpcome.com' + '/xpApk/xp-release_trade_v5.0.2-RELEASE_06-20.apk'
				}
				if (url) {
					window.location.href = url
				} else {
					this.showAlert(this.$t('down.stay_tuned'))
				}
			},
			showAlert(message) {
				this.message = message;
				this.alertShow = true;
				setTimeout(() => {
					this.alertShow = false;
				}, 2000);
			},

			getDownUrl() {
				this.$MyAxios.get('/api/versions/downloadUrl', {}, response => {
					if (response.code == 1) {
						this.showLoading = false;
						this.iosUrl = response.data.ios;
						this.androidUrl = response.data.android;
					}
				})
			},

		}
	}
</script>

<style lang='less'>
	#down-main-xp {
		overflow: hidden;
		min-height: 100vh;
		background: #fff;
		padding-bottom: 60px;

		.logo {
			width: 188px;
			height: 44px;
			margin: 64px auto 40px auto;
		}

		.h1 {
			position: relative;
			z-index: 2;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 56px;
			line-height: 80px;
			font-weight: bold;
			color: #1E2329;

			img {
				width: 18px;
				height: 20px;
				margin: 0 24px;
			}
		}

		.bg {
			width: 100%;
			height: 920px;
			margin-top: -40px;
		}

		.ul {
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			justify-content: space-around;

			.li {
				width: 320px;
				height: 96px;
				color: #fff;
				background: #1E2329;
				border-radius: 50px;
				margin-bottom: 30px;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 28px;

				img {
					width: 36px;
					height: 36px;
					display: block;
					margin-right: 20px;
				}
			}

			.li:nth-child(n+3) {
				background: #fff;
				color: #1E2329;
				border: 1px solid #1E2329;
			}
		}
	}

	.alert {
		position: fixed;
		z-index: 9;
		top: 40%;
		left: 50%;
		height: 76px;
		width: auto;
		padding: 0 30px;
		transform: translateX(-50%);
		border-radius: 16px;
		background: rgba(0, 0, 0, .9);
		color: #ffffff;
		line-height: 76px;
		font-size: 26px;
	}
</style>